const amplifyConfig = {
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_9xwUFZA8Z",
  aws_user_pools_web_client_id: "2jqrqk57s57865afu54upe99dc",
  aws_cognito_identity_pool_id: "us-east-1:4ae58bcd-82c8-413a-b644-c722021a12c2",
};

export default amplifyConfig;
